import React, { useEffect, useState } from "react";
import { AiFillQuestionCircle } from "react-icons/ai";
import "./portalView.css";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { portalView, removeGlossaryPortal, removeUserPortal } from "../../redux/actions/portalAction";
import Loading from "../../components/ui/loader/loader";
import moment from "moment";
import AssignUser from "./assignUserPortal";
import AddResource from "./addResource";
import { availableLanguages } from "../../components/data/language";
import errorToast from "../../components/toast/errorToast";
import EditPortal from "./editPortal";
import { Tooltip } from 'react-tooltip';
import successToast from "../../components/toast/successToast";
import { useAuth } from '../../context/AuthContext';

/**Portal-View Module */
const PortalView = () => {

  const [loading, setLoading] = useState(false);
  const [portalData, setPortalData] = useState({});
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState();
  const [showEdit, setEditShow] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([])
  const [seletedresource, setSelectedResource] = useState([])
  const userData = [];
  let { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const onHide = () => {
    setShow(!show);
  };

  const onClose = () => {
    setOpen(!open);
  };

  const onEditClose = () => {
    setEditShow(!showEdit)
  };

  useEffect(() => {
    dispatch(portalView(id, onSuccess, onError));
    setLoading(true);
  }, [id]);

  function reloadData() {
    dispatch(portalView(id, onSuccess, onError));
  }

  const handleUsersSelectAll = (items) => {
    if (items.length === selectedUsers.length) {
      setSelectedUsers([])
    } else {
      items.map((item) => {
        if (!selectedUsers.includes(item.user_id)) {
          setSelectedUsers((prev) => [...prev, item.user_id])
        }
      })
    }
  }

  const handleUserCheckbox = (userId) => {
    setSelectedUsers((prev) =>
      prev?.includes(userId)
        ? prev?.filter((id) => id !== userId)
        : [...prev, userId]
    )
  }

  const handleResourcechecbox = (resourseId) => {
    setSelectedResource((prevResources) =>
      prevResources.includes(resourseId)
        ? prevResources.filter((id) => id !== resourseId)
        : [...prevResources, resourseId]
    )
  }

  const handleResourceSelectAll = (items) => {
    if (items?.length === seletedresource.length) {
      setSelectedResource([])
    } else {
      items?.map((item) => {
        if (!seletedresource.includes(item.id)) {
          setSelectedResource((prev) => [...prev, item.id])
        }
      })
    }
  }



  const onSuccess = (data) => {
    setPortalData(data.data.data);
    setLoading(false);
  };

  const handleUsersRemove = () => {
    dispatch(removeUserPortal({ users: selectedUsers, portal_id: id }, onRemoveSuccess, onError))
  }

  const handleGlossaryRemove = (id) => {
    dispatch(removeGlossaryPortal({ id }, onRemoveSuccess, onError))
  }

  const onError = (data) => {
    errorToast(data.data.message);
  };

  const onRemoveSuccess = (data) => {
    dispatch(portalView(id, onSuccess, onError));
    successToast(data.data.message);
  };


  const getLangName = (value) => {
    let label = null;
    availableLanguages.forEach((itemdata) => {
      if (itemdata.value === value) {
        label = itemdata.label;
      }
    });
    return label;
  };

  return (
    <div className="w-100 d-flex flex-column" style={{ height: "100%" }}>

      {/* ── Header ─────────────────────────────────────────────────────── */}
      <div
        className="d-flex align-items-center border-bottom px-3 position-sticky top-0 bg-white"
        style={{ height: 53, flexShrink: 0 }}
      >
        <AiOutlineArrowLeft
          className="cursor_pointer me-2"
          style={{ color: "#4A81E0", fontSize: 20 }}
          onClick={handleGoBack}
        />
        <span className="fs_18 fw_500">{portalData?.portal_name || "Portal Detail"}</span>
      </div>

      {/* ── Content ────────────────────────────────────────────────────── */}
      <div style={{ overflowY: "auto", flex: 1 }}>
        {loading ? (
          <Loading text="Loading..." />
        ) : (
          <div className="p-2 text-start w-100">

            {/* Portal Details */}
            <div className="d-flex gap-4 align-items-center mb-2">
              <label className="fs_20 fw_600">Portal Detail</label>
              {isAdmin && (
                <div
                  className="d-flex cursor_pointer"
                  style={{ color: "#3367D6" }}
                  onClick={() => setEditShow(!showEdit)}
                >
                  <label className="fs_20 fw_600 cursor_pointer">EDIT</label>
                </div>
              )}
            </div>
            <div className="mb-4">
              <table className="custom-table">
                <tbody>
                  <tr>
                    <td>ID</td>
                    <td>{portalData?.id}</td>
                  </tr>
                  <tr>
                    <td>URL</td>
                    <td>
                      <a href={`/login/${portalData?.id}`} target="_blank" rel="noreferrer">
                        https://{window.location.host}/portal/{portalData?.id}
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>Display Name</td>
                    <td>{portalData?.portal_name}</td>
                  </tr>
                  <tr>
                    <td>Pricing Tier</td>
                    <td>{portalData?.price_tier === "advance" ? "Advance" : "Basic"}</td>
                  </tr>
                  <tr>
                    <td>
                      Retention Policy
                      <AiFillQuestionCircle data-tooltip-id="retentionTipRetention" />
                      <Tooltip id="retentionTipRetention" place="bottom" effect="solid" style={{ width: '400px' }}>
                        The number of days translation jobs are retained. The retention period starts when a job is completed.
                      </Tooltip>
                    </td>
                    <td>{portalData?.retention_policy} days</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Users */}
            <div className="d-flex align-items-center gap-3 mb-3">
              <h6 className="fw_600 fs_20 mb-0">Users</h6>
              {isAdmin && (
                <div className="d-flex gap-4">
                  <button
                    className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                    onClick={() => setShow(!show)}
                  >
                    <i className="bi bi-person-plus" /> Add User
                  </button>
                  <button
                    disabled={selectedUsers.length < 1}
                    className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                    onClick={handleUsersRemove}
                  >
                    <i className="bi bi-person-dash" /> Remove User
                  </button>
                </div>


              )}
            </div>
            <div className="card mb-4" style={{ overflow: "hidden" }}>
              <div className="table-responsive">
                <table className="table table-hover mb-0 portal-card-table">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: 40 }}>
                        <input
                          type="checkbox"
                          checked={selectedUsers?.length === portalData?.portalUsers?.length && portalData?.portalUsers?.length > 0}
                          onChange={() => handleUsersSelectAll(portalData?.portalUsers)}
                        />
                      </th>
                      <th>User Email</th>
                      <th className="text-nowrap">Added On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {portalData?.portalUsers?.length > 0 ? (
                      portalData.portalUsers.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedUsers?.includes(item.user_id)}
                              onChange={() => handleUserCheckbox(item.user_id)}
                            />
                          </td>
                          <td>{item?.user?.email}</td>
                          <td className="text-nowrap text-muted">
                            {moment(item?.createdAt).format("MMM D, YYYY h:mm A")}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center text-muted py-4">No users assigned</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Resources */}
            {isAdmin &&
              <div className="d-flex align-items-center gap-3 mb-3 mt-2">
                <h6 className="fw_600 fs_20 mb-0">Resources</h6>
                <button
                  className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                  onClick={() => setOpen(!open)}
                >
                  <i className="bi bi-plus-circle" /> Add Resource
                </button>
              </div>
            }

            {/* Glossaries */}
            <h6 className="fw_600 fs_16 mb-1">Glossaries</h6>
            <p className="fs_12 text-muted mb-3">
              Glossaries are custom dictionaries that help you consistently translate terms and named entities.{" "}
              <a href="https://cloud.google.com/translation-hub/docs/admin-enable-translations" target="_blank" rel="noreferrer">
                Learn more
              </a>
            </p>
            <div className="card mb-4" style={{ overflow: "hidden" }}>
              <div className="table-responsive">
                <table className="table table-hover mb-0 text-start portal-card-table">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: 40 }}>
                        <input
                          type="checkbox"
                          checked={seletedresource?.length === portalData?.glossaryPortals?.length && portalData?.glossaryPortals?.length > 0}
                          onChange={() => handleResourceSelectAll(portalData?.glossaryPortals)}
                        />
                      </th>
                      <th>Resource Name</th>
                      <th>Language Set</th>
                      <th>Portal Names</th>
                      <th className="text-nowrap">Created</th>
                      <th className="text-nowrap">Last Updated</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {portalData?.glossaryPortals?.length > 0 ? (
                      portalData.glossaryPortals.map((item, idx) => (
                        <tr key={idx}>
                          <td>
                            <input
                              type="checkbox"
                              checked={seletedresource.includes(item.id)}
                              onChange={() => handleResourcechecbox(item.id)}
                            />
                          </td>
                          <td>{item?.glossary?.name}</td>
                          <td style={{ maxWidth: 200 }}>
                            {item?.glossary?.language_set
                              ?.map((lang) => `${getLangName(lang)} (${lang})`)
                              .join(", ")}
                          </td>
                          <td>
                            {item?.glossary?.glossaryPortals
                              ?.map((p) => p?.portal?.portal_name)
                              .join(", ")}
                          </td>
                          <td className="text-nowrap text-muted">
                            {moment(item?.glossary?.createdAt).format("MMM D, YYYY")}
                          </td>
                          <td className="text-nowrap text-muted">
                            {moment(item?.glossary?.updatedAt).format("MMM D, YYYY")}
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleGlossaryRemove(item.id)}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-4">No glossaries assigned</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        )}
      </div>

      {open && <AddResource show={open} onHide={onClose} portalId={portalData?.id} reloadData={reloadData} />}
      {show && <AssignUser show={show} onHide={onHide} userData={userData} portalId={portalData?.id} />}
      {showEdit && <EditPortal show={showEdit} onHide={onEditClose} portalData={portalData} reloadData={reloadData} />}

    </div>
  );
};

export default PortalView;
